import { Currency } from "@redotech/money/currencies";
import {
  any,
  array,
  boolean,
  number,
  object,
  record,
  string,
  union,
  enum as zEnum,
  infer as zInfer,
  null as zNull,
} from "zod";

const SeoParser = object({
  title: string().optional(),
  description: string().optional(),
});

const ProductVariantParser = object({
  id: string(),
  gid: string(),
  availableForSale: boolean(),
  price: object({ amount: string(), currencyCode: zEnum(Currency) }),
  title: string(),
});
export type ProductVariant = zInfer<typeof ProductVariantParser>;

export const ProductDetailsParser = object({
  id: string(),
  variantId: string(),
  title: string(),
  description: string(),
  seo: SeoParser.optional(),
  variants: object({ nodes: array(ProductVariantParser) }),
  url: string().optional(),
  metafields: array(
    object({
      key: string(),
      description: string().optional(),
      jsonValue: union([
        string(),
        zNull(),
        array(any()),
        number(),
        boolean(),
        record(string(), any()),
      ]),
    }),
  ).optional(),
  additionalInfo: string().optional(),
}).optional();
export type ProductDetails = zInfer<typeof ProductDetailsParser>;

export const RelevantProductInfoParser = object({
  productId: string(),
  title: string(),
  description: string(),
});
export type RelevantProductInfo = zInfer<typeof RelevantProductInfoParser>;

export const GetRelevantProductsOutputParser = object({
  products: array(RelevantProductInfoParser),
});
export type GetRelevantProductsOutput = zInfer<
  typeof GetRelevantProductsOutputParser
>;
